export const refParametersPartial = '#/components/parameters/';

export const refSchemasPartial = '#/components/schemas/';
